import { render } from "./Accordion.vue?vue&type=template&id=f8dabd9e"
import script from "./Accordion.vue?vue&type=script&lang=ts"
export * from "./Accordion.vue?vue&type=script&lang=ts"
script.render = render

export default script